import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect, useSelector } from 'react-redux';


//ACTION CREATORS
import { edeSearch, clearEDESearch, addToBOB, idProofing, fetchEnrollerDetails } from '../../actions/actionCreators';

//Components
import EDESearch from './EDESearch';
import EDESearchResults from './EDESearchResults';

//Containers
import { configs } from '@constants/configs/configs';

import { fetchMockModal, showModal } from '@actions/common/actionCreators';
import { commonModalTypes as MODAL_TYPES } from '@constants/common/modals/commonModalTypes';
import { DOCUMENT_TYPES } from '../../constants/constants';
import { removeFormat } from '@utils/miscellaneous/formatNumber';
import { useOutletContext } from 'react-router-dom';
import { environmentSelector } from '@selectors/commonSelectors';
import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes';



const EDESearchContainer = (props) => {
    const outletContextProps = useOutletContext();
    const mergedProps = { ...outletContextProps, ...props };

    const { endpoints } = configs;
    const {
        actions,
        actions: {
            showModal,
            clearEDESearch
        },
        environment: {
            stateCode,
            exchangeName,
            links: environmentLinks
        },
        values,
        handleChange,
        handleBlur,
        handleFocus,
        errors,
        resetFields,
        resetErrors,
        edeSearchResult,
        emptyFieldErrMsg,
        setEmptyFieldErrMsg,
        setFieldErrors,
        nonMandatoryFieldErrors,
        setNonMandatoryFieldErrors,
        idProofingResponse: {
            identityProofId
        },
        touched,
        validate,
        fetchEnrollerDetailsResponse
    } = mergedProps;

    const { activeModuleName } = useSelector(environmentSelector).user;
    values.documentNumber = values.documentType === DOCUMENT_TYPES[stateCode].SSN ? removeFormat(values.documentNumber) : values.documentNumber;

    const agentOtpFeatureEnabled = activeModuleName.toUpperCase() === ALL_USER_ROLES.ASSISTER ? fetchEnrollerDetailsResponse?.assisterOtpFeature : fetchEnrollerDetailsResponse?.agentOtpFeature;
    // Result container scrolls to view
    const scrollSmoothHandler = (id) => {
        const getById = document.getElementById(id);
        window.scrollTo({
            top:getById.offsetTop,
            behavior:'smooth'
        });
    };

    const isDocumentTypeSSN = values.documentType === DOCUMENT_TYPES[stateCode].SSN;
    const fieldsToResetOnSSN = !isDocumentTypeSSN ? ['ssn'] : [];
    const fields = values.searchConsumer === 'ssn' ? fieldsToResetOnSSN : ['email', 'zipCode', 'city'];
    let searchBySSN = values.searchConsumer === 'ssn';
    let searchByName = values.searchConsumer === 'name';

    const filteredTouchedFields = Object.keys(touched)
        .filter(key => fields.includes(key))
        .reduce((obj, key) => {
            obj[key] = touched[key];
            return obj;
        }, {});


    //On search action, clear any search results state present
    const handleSubmit = () => {
        const touchedFields = Object.entries(filteredTouchedFields).reduce((acc, [key, value]) => {
            if(!value) {
                acc[key] = values[key];
            } else {
                const errObj = validate({ [key]: values[key] });
                if(Object.keys(errObj).length) {
                    acc[key] = values[key];
                }
            }
            return acc;
        }, {});

        const errs = validate(touchedFields);
        if( Object.keys(errs).length) return;



        let ssnVal = '';
        if (searchBySSN) {
            ssnVal = isDocumentTypeSSN ? values.documentNumber.split('-').join('') : (values.ssn).split('-').join('');
        }

        if( Object.keys(errs).length === 0) {
            let passIdentityProofId = {
                firstName: searchByName ? values.firstName : '',
                lastName: searchByName ? values.lastName : '',
                email: searchByName ? values.email : '',
                city: searchByName ? values.city : '',
                zipCode: searchByName ? values.zipCode : '',
                ssn: ssnVal,
                dob: values.searchConsumer==='name'? values.dob_name : values.dob,
                identityProofId: identityProofId
            };
            if(searchByName) {
                delete passIdentityProofId.dob_name;
            }
            actions.edeSearch(endpoints.EDE_SEARCH_ENDPOINT, { passIdentityProofId, scrollSmoothHandler, id: 'ede-search-result__found-records' } );
            clearEDESearch();
        }
        //setEmptyFieldErrMsg(areFieldsEmpty);
    };

    const handleAddToBOBClick = () => {

        return actions.addToBOB(
            endpoints.EDE_SEARCH_ADD_TO_BOB,
            {
                memberName:`${edeSearchResult.primaryHousehold.firstName} ${edeSearchResult.primaryHousehold.lastName}`,
                individualId: edeSearchResult.primaryHousehold.householdId,
                identityProofingId: edeSearchResult.identityProofId,
            }
        );
    };

    const becomeAOR = () => {
        return showModal({
            modalType: MODAL_TYPES.BECOME_AOR_MODAL,
            modalData: {
                memberName: `${edeSearchResult.primaryHousehold.firstName} ${edeSearchResult.primaryHousehold.lastName}`,
                handleAddToBOBClick
            }
        });
    };
    
    const onAuthenticateConsumerByOtp = () => {
        if(agentOtpFeatureEnabled)
            return showModal({
                modalType: MODAL_TYPES.SELF_DESIGNATION_OTP_MODAL,
                modalData: {
                    becomeAOR,
                    edeSearchResult
                }
            }); 
        else 
            becomeAOR();
    };

    //On clear or cancel, reset all input fields, clear search result state and clear all error messages
    const clearData = () => {
        resetFields(fields, [{ emptyFieldErrMsg }]);
        clearEDESearch();
        setEmptyFieldErrMsg(false);
    };

    const backToDashboard = () => {
        const normalizedRole = activeModuleName.toUpperCase(); 
        const redirectUrl = normalizedRole === ALL_USER_ROLES.ASSISTER ? endpoints.BACK_TO_ASSISTER_DASHBOARD : endpoints.BACK_TO_BROKER_DASHBOARD;
        window.location.href = redirectUrl;
    };
    

    const startNewApplication = () => {
        return window.location.href = endpoints.EDE_ADD_CONSUMER.processReplacements({ identityProofId });
    };

    return (
        <Fragment>

            <EDESearch { ...{
                values,
                stateCode,
                handleChange,
                handleBlur,
                handleFocus,
                handleSubmit,
                clearData,
                clearEDESearch,
                errors,
                emptyFieldErrMsg,
                resetErrors,
                setEmptyFieldErrMsg,
                setFieldErrors,
                setNonMandatoryFieldErrors,
                nonMandatoryFieldErrors,
                isDocumentTypeSSN,
                searchEnrollerByName: fetchEnrollerDetailsResponse?.searchByName?.toUpperCase() === 'TRUE'
            } }/>
            { Object.keys(edeSearchResult).length > 0 && Object.keys(errors).length === 0 &&
                <EDESearchResults { ...{ edeSearchResult, handleChange, handleFocus, backToDashboard, onAuthenticateConsumerByOtp, agentOtpFeatureEnabled, addToBOB, clearData, startNewApplication, showModal, environmentLinks, exchangeName } }/>
            }
        </Fragment>
    );

};

const mapStateToProps = state => ({
    spinner: state.common.spinner,
    environment: state.common.environment,
    edeSearchResult: state.edeSearch.results,
    idProofingResponse: state.edeSearch.response,
    fetchEnrollerDetailsResponse: state.edeSearch.enrollerDetailsResponse
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        fetchMockModal,
        showModal,
        edeSearch,
        idProofing,
        clearEDESearch,
        addToBOB,
        fetchEnrollerDetails
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(EDESearchContainer);